import DashboardSidebar from '@/components/dashboard/sidebar';
import Footer from '@/components/layouts/footer';
import Header from '@/components/layouts/header';
import CategoryMenu from '@/components/layouts/menu/category-menu';
import MobileNavigation from '@/components/layouts/mobile-navigation';
import { cn } from '@/lib/cn';

type Props = {
  layout?: string;
  className?: string;
};

export default function DashboardLayout({
  children,
  className,
}: React.PropsWithChildren<Props>) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-100 transition-colors duration-150">
      <Header />
      <CategoryMenu />

      <div
        className={cn(
          '_dashboard mx-auto flex w-full max-w-1920 flex-col items-stretch bg-gray-100 px-5 py-10 lg:flex-row xl:px-8 xl:py-14 2xl:px-14',
          className,
        )}
      >
        <DashboardSidebar className="hidden shrink-0 lg:block lg:w-80 ltr:mr-8 rtl:ml-8" />
        {children}
      </div>

      <Footer />
      <MobileNavigation />
    </div>
  );
}
